<template>
  <div class="text--center text--white">
    <h2 class="fr-h2 fr-mb-6w text--white">Pourquoi agir ?</h2>

    <ul class="fr-grid-row fr-grid-row--gutters list-style-none">
      <li class="fr-col-lg-3 fr-col-6">
        <span
          class="fr-icon-money-euro-circle-line fr-mb-1w fr-p-2w display-inline-block background--bleu-picto border-radius--full fr-mb-3w"
          aria-hidden="true"
        />
        <h3 class="fr-h4 text--white fr-mb-1w">Pour vos économies</h3>
        <p>Toutes les aides financières et des astuces pour réduire vos factures d’eau, d’énergie, de chauffage…</p>
      </li>

      <li class="fr-col-lg-3 fr-col-6">
        <span
          class="fr-icon-lungs-line fr-mb-1w fr-p-2w display-inline-block background--bleu-picto border-radius--full fr-mb-3w"
          aria-hidden="true"
        />
        <h3 class="fr-h4 text--white fr-mb-1w">Pour votre santé</h3>
        <p>Des recettes saines et gourmandes, des conseils pour choisir de bons produits au quotidien…</p>
      </li>

      <li class="fr-col-lg-3 fr-col-6">
        <span
          class="fr-icon-parent-line fr-mb-1w fr-p-2w display-inline-block background--bleu-picto border-radius--full fr-mb-3w"
          aria-hidden="true"
        />
        <h3 class="fr-h4 text--white fr-mb-1w">Pour guider vos choix</h3>
        <p>
          Changer de voiture, isoler votre logement, récupérer l'eau de pluie… Toutes les solutions sont sur J’agis !
        </p>
      </li>

      <li class="fr-col-lg-3 fr-col-6">
        <span
          class="fr-icon-heart-line fr-mb-1w fr-p-2w display-inline-block background--bleu-picto border-radius--full fr-mb-3w"
          aria-hidden="true"
        />
        <h3 class="fr-h4 text--white fr-mb-1w">Pour s'adapter au climat</h3>
        <p>
          Des solutions pour vous préparer et mieux vivre les fortes températures, tout en agissant dès aujourd’hui.
        </p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
  .background--bleu-picto {
    background-color: #1212ab;
  }
</style>
